<script setup>
import StatCard from "@/components/global-themed/StatCard.vue";
import HintSquare from "@/components/global-themed/HintSquare.vue";
import {computed} from "vue";
import {useStore} from "vuex";
import _ from "lodash";

const store = useStore();

const backlinks = computed(() => store.getters['competitionV2/backlinks'] ?? []);

const domainAuthority = computed(() => store.getters['competitionV2/domainAuthority']);

const domains = computed(() => _.uniq(backlinks.value.map(backlink => backlink.domain)).length);

const externalBacklinks = computed(() => backlinks.value.length);

</script>

<template>
  <div class="tw-grid-cols-3 tw-grid tw-gap-4">
    <StatCard>
      <template #stat>
        {{ domainAuthority ?? 'N/A' }}
      </template>
      <template #title>
        <span>Domain Authority</span>
        <HintSquare
          hint="Our Domain Authority score is calculated using proprietary metrics that assess the overall credibility and influence of a website based on its web of backlinks."
        />
      </template>
    </StatCard>

    <StatCard>
      <template #stat>
        {{ domains }}
      </template>
      <template #title>
        <span>Number of Referring Domains</span>
        <HintSquare
          hint="This is the count of unique domains that each host at least one backlink pointing to the selected website."
        />
      </template>
    </StatCard>

    <StatCard>
      <template #stat>
        {{ externalBacklinks }}
      </template>
      <template #title>
        <span>Number of External Backlinks</span>
        <HintSquare
          hint="This represents the number of individual backlinks directing users to the selected website."
        />
      </template>
    </StatCard>
  </div>
</template>
